import { turnstile } from "./turnstile.js";

/* The unsubscribe form is a plain server-rendered POST, no fetch/Ajax - this
   component renders the Turnstile widget and carries the two bits of state
   the shared form-field macros bind to. */
export function unsubscribe() {
  return {
    ...turnstile("newsletter-unsubscribe"),

    init() {
      this.initTurnstile();
    },

    email: "",
    submitting: false,
  };
}
